import type { IconSvgObject } from './types';

const FlashIcon: IconSvgObject = [
  ["path", { d: "M9.9996 12.9998H4.4996L13.9996 2V10.985M14.0004 11.0002H19.5004L10.0004 22V13.015", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FlashIcon;
